const socialLinks = {
  facebook: "https://www.facebook.com/EWMIsNowNuvamaWealth",
  linkedin: "https://www.linkedin.com/company/edelweiss-wealth-management/",
  instagram: "https://www.instagram.com/EWMisnownuvamawealth/",
  twitter: "https://twitter.com/EWMIsNuvamaWlth",
  apiConnectMail: "APIconnect@nuvama.com",
  supportEmail: "APIsupport@nuvama.com",
  complianceOfficer: "complianceofficer.nwil@nuvama.com",
};

export default socialLinks;
